export const DOLLAR_SIGNS = '$$$'

export const getPriceRange = (position: number) => Math.floor(position / 2) + 1
